import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Badge, Card, CardBody } from "reactstrap";

const PlanDetailsModal = ({ open, onClose, organization }) => {
  const planDetails = organization?.plan_details;

  if (!planDetails) {
    return null;
  }

  const formatValue = (value) => {
    if (value === 999999999999999) return 'Unlimited';
    if (value === null || value === undefined) return 'N/A';
    return value.toLocaleString();
  };

  const calculatePercentage = (used, max) => {
    if (max === 999999999999999) return 0;
    if (max === 0) return 0;
    return Math.round((used / max) * 100);
  };

  const getProgressColor = (percentage) => {
    if (percentage >= 90) return 'danger';
    if (percentage >= 70) return 'warning';
    return 'success';
  };

  // Calculate used and total values
  const creditsUsed = planDetails.credits || 0;
  const creditsTotal = planDetails.max_credits || 0;
  const creditsPercentage = calculatePercentage(creditsUsed, creditsTotal);

  return (
    <Modal isOpen={open} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>
        <span style={{ fontSize: "18px", fontWeight: "700" }}>
          Plan Details
        </span>
      </ModalHeader>
      <ModalBody>
        {/* Organization Info */}
        <Card className="mb-3" style={{ backgroundColor: '#f8f9fa' }}>
          <CardBody>
            <Row>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Organization:</strong> {organization?.name || 'N/A'}
                </div>
                <div className="mb-2">
                  <strong>Website:</strong> {organization?.website || 'N/A'}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-2">
                  <strong>Type:</strong> {organization?.type || 'N/A'}
                </div>
                <div className="mb-2">
                  <strong>Premium Status:</strong>{' '}
                  <Badge color={organization?.is_premium ? 'success' : 'secondary'}>
                    {organization?.is_premium ? 'Premium' : 'Free'}
                  </Badge>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Plan Information */}
        <h6 className="mb-3" style={{ fontWeight: '600', fontSize: '16px' }}>
          Plan Information
        </h6>
        <Row className="mb-4">
          <Col md={6}>
            <div className="mb-2">
              <strong>Plan Name:</strong> {planDetails.name || 'N/A'} {organization?.is_on_trial && `(${organization?.trial_period || 14} Days Trial)`}
            </div>
            <div className="mb-2">
              <strong>Plan Type:</strong>{' '}
              <Badge color="primary" style={{ textTransform: 'capitalize' }}>
                {planDetails.type || 'N/A'}
              </Badge>
            </div>
            <div className="mb-2">
              <strong>Provider:</strong>{' '}
              <Badge color="info" style={{ textTransform: 'capitalize' }}>
                {planDetails.provider || 'N/A'}
              </Badge>
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-2">
              <strong>Amount:</strong>{' '}
              {planDetails.amount !== null && planDetails.amount !== undefined
                ? `${planDetails.currency || '€'}${planDetails.amount}`
                : 'N/A'}
            </div>
            {/* <div className="mb-2">
              <strong>Seats:</strong> {planDetails.seats || 0}
            </div> */}
            {/* <div className="mb-2">
              <strong>Profile View Credits:</strong> {formatValue(planDetails.profile_view_credit)}
            </div> */}
          </Col>
        </Row>

        {/* Credits Usage */}
        <h6 className="mb-3" style={{ fontWeight: '600', fontSize: '16px' }}>
          Credits Usage
        </h6>

        {/* Match Credits */}
        <Card className="mb-3">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <strong>Credits</strong>
              <span style={{ fontSize: '14px', color: '#666' }}>
                {formatValue(creditsUsed)}  / {formatValue(creditsTotal)}
              </span>
            </div>
            {creditsTotal !== 999999999999999 && (
              <>
                <div className="progress" style={{ height: '20px' }}>
                  <div
                    className={`progress-bar bg-${getProgressColor(creditsPercentage)}`}
                    role="progressbar"
                    style={{ width: `${creditsPercentage}%` }}
                    aria-valuenow={creditsPercentage}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {creditsPercentage}%
                  </div>
                </div>
                <div className="mt-2" style={{ fontSize: '13px', color: '#666' }}>
                  <div>
                    <strong>Total Used (Historical):</strong> {formatValue(planDetails.total_used_credits || 0)}
                  </div>
                </div>
              </>
            )}
          </CardBody>
        </Card>

        {/* Plan Dates */}
        {organization?.plan_renewed_at && (
          <div className="mt-3 text-muted" style={{ fontSize: '13px' }}>
            <div>
              <strong>Plan Renewed At:</strong>{' '}
              {new Date(organization.plan_renewed_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </div>
          </div>
        )}

        {organization?.plan_expires_at && planDetails?.type === 'annual' && planDetails?.provider !== 'pitti' && (
          <div className="mt-3 text-muted" style={{ fontSize: '13px' }}>
            <div>
              <strong>Plan Expires At:</strong>{' '}
              {new Date(organization.plan_expires_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PlanDetailsModal;
